module.exports = __webpack_public_path__ + "img/smart_tales_blue.a0c5c21f.png";